import React from 'react';
import {
  Platform,
  TouchableOpacity,
  TouchableOpacityProps,
} from 'react-native';

export const EqualHeightTouchableOpacity: React.FC<TouchableOpacityProps> = (
  props,
) => {
  return (
    <TouchableOpacity
      {...props}
      ref={(ref) => {
        // Make item heights equal on web by applying the style directly to
        // the parent DOM element since React Native doesn't provide a way
        // to set styles on the item container
        if (
          Platform.OS === 'web' &&
          ref instanceof HTMLElement &&
          ref.parentElement
        ) {
          ref.parentElement.style.flex = '1';
        }
      }}
    />
  );
};
